import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "dropdown language-dropdown" };
const _hoisted_2 = {
    class: "dropdown-toggle fw-medium position-relative pt-0 pb-0 bg-transparent border-0 transition lh-1 d-flex align-items-center",
    type: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_3 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" };
const _hoisted_4 = { class: "title d-flex align-items-center justify-content-between px-3 pt-3" };
const _hoisted_5 = { class: "text-black fw-bold" };
const _hoisted_6 = { class: "ps-0 mb-0 list-unstyled dropdown-body" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "me-2" };
const _hoisted_9 = {
    key: 0,
    class: "flaticon-check position-absolute end-0 me-3",
    style: { "top": "50%", "transform": "translateY(-50%)" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "flaticon-translate me-2" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.currentLanguageCode.toUpperCase()), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.language')), 1)
            ]),
            _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: lang.code,
                        class: _normalizeClass(["position-relative fw-semibold text-black-emphasis px-3 py-2", { 'bg-light': _ctx.currentLanguage === lang.code }]),
                        style: { "cursor": "pointer" },
                        onClick: ($event) => (_ctx.changeLanguage(lang.code))
                    }, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(lang.flag), 1),
                        _createTextVNode(" " + _toDisplayString(lang.name) + " ", 1),
                        (_ctx.currentLanguage === lang.code)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                            : _createCommentVNode("", true)
                    ], 10, _hoisted_7));
                }), 128))
            ])
        ])
    ]));
}
